import BaseService from "./baseService";
import { WorkflowPayload } from "../declarations/interface";

class FlowService extends BaseService {
  constructor() {
    super('/workflow-list')
  }

  async getWorkflowById(id: string) {
    return this.get(`/${id}`);
  }

  async createWorkflow(workflow: WorkflowPayload) {
    return this.post(`/workflow-sequence`, workflow);
  }

  async updateWorkflow(workflow: WorkflowPayload) {
    return this.patch(`/workflow-sequence/${workflow.workflow_id}`, workflow);
  }

  async updateWorkflowName(id: string, name: string) {
    return this.patch(`/${id}`, { workflow_name: name });
  }

  async deleteWorkflowById(id: string) {
    return this.remove(`/${id}`);
  }
}

export default new FlowService();
